export const environment = {
  production: true,
  API_BASE_URL: 'https://dev.truckopis.com',
  version: '1.0115.24', //last date updated
  budget_defaultRecieverId: 17435
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts